import { Pipe, PipeTransform } from "@angular/core";
import { ListOption } from "../../core/editable-fields/dropdown/dropdown.component";

//  Converts an array of API SelectOptions into a ListOptions.  Can accept objects in {Label: '', Name: ''}
//  or {Key: '', Value:''} format.
@Pipe({
    name: 'toListOption',
    standalone: false
})
export class ListOptionPipe implements PipeTransform {
    transform(arr: any[]): ListOption[] {
        if (!arr)
            return [];

        let retVal = [];
        for (let option of arr) {
            let displayName = '';
            let value = ''

            if (typeof (option) == 'string') {
                displayName = option;
                value = option;
            }
            else {
                displayName = option.Label ?? option.Key;
                value = option.Name ?? option.Value;
            }

            //  If a value is an array this means it's grouped and needs to have child values turned
            //  into the ListOption shape.
            if (Array.isArray(value)) {
                let subValues = []

                for (let subOption of option.Value) {
                    const subDisplayName = subOption.Label ?? subOption.Key;
                    const subValue = subOption.Name ?? subOption.Value;
                    subValues.push(new ListOption(subDisplayName, subValue));
                }
                retVal.push(new ListOption(displayName, subValues));

            }
            else
                retVal.push(new ListOption(displayName, value));
        }

        return retVal;
    }
}
